export default __webpack_public_path__ + "static/6-693376c1c445eab467822332105b807f.jpg";